import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { RouterProvider } from 'react-aria-components'
import { Toaster } from 'react-hot-toast'

import { env } from '@/shared/config'
import { ActiveLawProvider } from '@/shared/lib/cookieyes/provider/context'
import { I18nContext, type Language, type Translation } from '@/shared/lib/i18n'
import { ModalProvider } from '@/shared/ui/modal'
import { DebugOverlay } from '@/widgets/debug'

import { ScriptsProvider } from './scripts-provider'

const queryClient = new QueryClient()

export function Providers({ i18n, lang, children }: React.PropsWithChildren<{ i18n: Translation; lang: Language }>) {
    const router = useRouter()

    return (
        <QueryClientProvider client={queryClient}>
            <I18nContext value={{ i18n, lang }}>
                <ActiveLawProvider>
                    <Toaster />
                    <ModalProvider />

                    <DebugOverlay enable={env.DEBUG_ENABLE}>
                        <RouterProvider navigate={(href, opts) => router.push(href, undefined, opts)}>
                            <ScriptsProvider>{children}</ScriptsProvider>
                        </RouterProvider>
                    </DebugOverlay>
                </ActiveLawProvider>
            </I18nContext>
        </QueryClientProvider>
    )
}
